import { FiTimeRangeMenuModule } from './../fi-time-range-menu/fi-time-range-menu.module';
import { NgModule } from '@angular/core';
import { FiReportWidgetComponent } from './fi-report-widget.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiLoadingModule } from '../fi-loading/fi-loading.module';
import { FiAppTextSharedModule } from '../app-text';
import { FiMatIconCheckboxMenuModule } from '../fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { CommonModule } from '@angular/common';
import { FiRenameWidgetDialogComponent } from './fi-rename-widget-dialog/fi-rename-widget-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { FiReportWidgetDialogsService } from './fi-report-widget-dialogs.service';
import { FiReportWidgetDetailsHeaderComponent } from './fi-report-widget-details-header/fi-report-widget-details-header.component';
import { FiReportWidgetNewWidgetTypeSelectStepComponent } from './new-report-widget-dialog/new-widget-type-select-step/new-widget-type-select-step.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiNewReportWidgetFilterSettingsHeaderComponent } from './new-report-widget-dialog/fi-widget-filter-settings-header/fi-new-report-widget-filter-settings-header.component';
import { FiNewReportWidgetNameDescriptionEditorComponent } from './new-report-widget-dialog/fi-widget-name-description-editor/fi-new-report-widget-name-description-editor.component';
import { FiNewReportWidgetFilterSettingsFooterComponent } from './new-report-widget-dialog/fi-widget-filter-settings-footer/fi-new-report-widget-filter-settings-footer.component';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        FiMatIconCheckboxMenuModule,
        FiLoadingModule,
        FiAppTextSharedModule,
        FiTimeRangeMenuModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        MatDividerModule,
    ],
    declarations: [
        FiReportWidgetComponent,
        FiRenameWidgetDialogComponent,
        FiReportWidgetDetailsHeaderComponent,
        FiReportWidgetNewWidgetTypeSelectStepComponent,
        FiNewReportWidgetFilterSettingsHeaderComponent,
        FiNewReportWidgetNameDescriptionEditorComponent,
        FiNewReportWidgetFilterSettingsFooterComponent,
    ],
    exports: [
        FiReportWidgetComponent,
        FiRenameWidgetDialogComponent,
        FiReportWidgetDetailsHeaderComponent,
        FiReportWidgetNewWidgetTypeSelectStepComponent,
        FiNewReportWidgetFilterSettingsHeaderComponent,
        FiNewReportWidgetNameDescriptionEditorComponent,
        FiNewReportWidgetFilterSettingsFooterComponent,
    ],
    providers: [FiReportWidgetDialogsService],
})
export class FiReportWidgetModule {}
